<template>
  <div id="app">
    <router-view
      v-if="!$route.meta.keepAlive && isGetCms && isLogin == true"
    ></router-view>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive && isGetCms && isLogin == true"
      ></router-view>
    </keep-alive>
  </div>
</template>
<script>
import cc from "./utils/common.js";
import { gameapi } from "./api/index";
export default {
  data() {
    return {
      isLogin: false,
      requestNum: 0,
      isGetCms: false
    };
  },
  async created() {
    // 判断是否登录
    cc.checkLogin(async () => {
      this.isLogin = true;
    });
    //await this.getCMSData();
    await this.gameapi();
  },
  async mounted() {
    // 埋点
    this.maiDian();
    //监控网络
    this.checkNet();
    //开启全屏
    this.fullScreen();
  },
  methods: {
    // 埋点
    maiDian() {
      if ($.isApp) {
        $.AppReady(function(bridge) {
          var title = "10004-null-100060/null-会员日抽奖-null-null-null"; // 埋点title字符串放这里
          if ($.os.android) {
            bridge.setNewPageTitle(title);
          } else {
            bridge.setNewPageTitle("", title);
          }
        });
      }
    },
    checkNet() {
      try {
        window.addEventListener("offline", () => {
          cc.toast("请检查网络连接是否正常");
        });
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * @description 全屏沉浸式访问 url需要加?wx_navbar_transparent=true
     */
    fullScreen() {
      try {
        $.AppReady(Bridge => {
          if ($.os.android) {
            // 沉浸式
            Bridge.enableTranslucentBar(true);
          } else if ($.os.ios && window.SNNativeClient) {
            //导航栏
            window.SNNativeClient.setNavigationHiden(0);
            //全屏
            window.SNNativeClient.callOpenWebViewFullScreen("1");
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async getCMSData() {
      try {
        let res = await cc.getCMSData("ddcj");
        if (cc.isObject(res)) {
          cc.UTILS.layoutObject(res);
          this.isGetCms = true;
          console.log("处理后的cms数据：", cc.UTILS.resourceData);
        } else {
          if (this.requestNum === 3) {
            cc.toast("网络开小差了，请稍后再试！");
          } else {
            this.requestNum++;
            await this.getCMSData();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async gameapi() {
      try {
        let activityCode = cc.getQueryString("activityCode");
        let res = await gameapi(activityCode);
        console.log("gameapi-->", res);
        if (cc.isJSON(res.data.result.elementJson)) {
          cc.gameapi = JSON.parse(res.data.result.elementJson);
          this.isGetCms = true;
          console.log("处理后的gameapi数据：", cc.gameapi);
        } else {
          //console.log("gameapi数据不正确");
          if (this.requestNum === 3) {
            cc.toast("网络开小差了，请稍后再试！");
          } else {
            this.requestNum++;
            await this.gameapi();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
